export const useLocalStorage = () => {
  const setItem = (key: string, item: any): void => {
    try {
      const stringItem = JSON.stringify(item);
      window.localStorage.setItem(key, stringItem);
    } catch (error) {}
  };

  const getItem = (key: string): any => {
    const item = window.localStorage.getItem(key) || false;
    try {
      return item ? JSON.parse(item) : null;
    } catch (error) {}
  };

  const removeItem = (key: string): void => {
    window.localStorage.removeItem(key);
  };

  const clear = (): void => {
    window.localStorage.clear();
  };

  return { setItem, getItem, removeItem, clear };
};
